import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { StampStatisticsService } from './StampStatistics.service';
import { ApiEvsService } from '../../../../common/services/ApiEvs.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { UtilityService } from '../../../../common/services/Utility.service';
import { ModalCancelStampComponent } from '../../qrcode/popup/modalCancelStamp.component';
import { BatchService } from '../../qrcode/batchstamp/batch.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { environment } from '../../../../../environments/environment';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;
declare var Chartist: any;
let that;

@Component({
  selector: 'evs-statistic-evs',
  templateUrl: 'stamp-evs-dashboard.template.html',
  styleUrls: ['style.css'],
  providers: [StampStatisticsService],
})
export class StampEvsDashboardComponent implements OnInit {
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';

  modalRef: BsModalRef;
  @ViewChild('lgModal') lgModal: ModalDirective;
  public title = 'Tổng quan';
  public message: { content: string; class: string } = {
    content: '',
    class: '',
  };
  public filterTimeForm: FormGroup;

  public totalStamps: any = 0;
  public totalStampsActive: any = 0;

  public totalOrders: any = 0;
  public totalOrdersGenStamp: any = 0;
  public totalOrdersNonActive: any = 0;

  public totalLogsScan: any = 0;
  public totalStampScan: any = 0;

  public totalStampsSold: any = 0;
  public totalStampsSoldCodeId: any = 0;
  public totalStampsSoldCodeSms: any = 0;
  public isDisableService: Boolean = false;
  public totalUserScan: any = 0;
  allLocation: any = '';
  tabBase: any = 1;

  overView: any = {};
  getDashboardStatisticsBH: any = {};
  getDashboardStatisticsPP: any = {};
  orders: any = [];
  services: any = [];
  batchs: any = [];
  stores: any = [];
  provinces: any = [];
  province_data_page: any = [];
  warnings: any = [];
  scanStatus: any = [];
  scanStatusLocation: any = [];
  warningFilter: any = {};
  cities: any = [];

  countAlertRepeatTime: any = null;  // Warranty Reminder Logs mock
  warrantyDashboardData: any = null;
  filteredWarrantyLogs = [];
  warrantyFilter: any = {
    type: 'all',
    status: 'all',
    sentTime: null,
    page: 1,
    pageSize: 5
  };
  warrantyTotalRow: number = 0;
  warrantyTotalPage: number = 0;
  warrantyPages: number[] = [];

  // Warranty Time Filter
  warrantyTimeFilter = 'today';
  warrantyTimeFilterLabel = 'Hôm nay';

  onWarrantyTimeFilterChange() {
    const labels = {
      'today': 'Hôm nay',
      'yesterday': 'Hôm qua',
      'this_week': 'Tuần này',
      'this_month': 'Tháng này',
      'custom': 'Tùy chỉnh'
    };
    this.warrantyTimeFilterLabel = labels[this.warrantyTimeFilter] || 'Hôm nay';

    if (this.warrantyTimeFilter === 'custom') {
      setTimeout(() => {
        $('#warrantyDateFrom').datepicker({ format: 'dd/mm/yyyy' });
        $('#warrantyDateTo').datepicker({ format: 'dd/mm/yyyy' });
      }, 100);
    } else {
      this.loadWarrantyDashboard();
    }
  }

  applyCustomWarrantyTimeFilter() {
    this.loadWarrantyDashboard();
  }

  loadWarrantyDashboard() {
    let params: any = {};
    if (this.warrantyTimeFilter === 'custom') {
      let fromStr = $('#warrantyDateFrom').val();
      let toStr = $('#warrantyDateTo').val();
      if (fromStr) params.from = moment(fromStr, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (toStr) params.to = moment(toStr, 'DD/MM/YYYY').format('YYYY-MM-DD');
    } else if (this.warrantyTimeFilter === 'today') {
      params.from = moment().format('YYYY-MM-DD');
      params.to = moment().format('YYYY-MM-DD');
    } else if (this.warrantyTimeFilter === 'yesterday') {
      params.from = moment().subtract(1, 'days').format('YYYY-MM-DD');
      params.to = moment().subtract(1, 'days').format('YYYY-MM-DD');
    } else if (this.warrantyTimeFilter === 'this_week') {
      params.from = moment().startOf('isoWeek').format('YYYY-MM-DD');
      params.to = moment().endOf('isoWeek').format('YYYY-MM-DD');
    } else if (this.warrantyTimeFilter === 'this_month') {
      params.from = moment().startOf('month').format('YYYY-MM-DD');
      params.to = moment().endOf('month').format('YYYY-MM-DD');
    }

    this.apiEvsService.get('/qr-core-aps/warranty-reminder/dashboard', params).subscribe(
      (res: any) => {
        if (res.code === 1) {
          this.warrantyDashboardData = res.data;
        } else {
          this.toastr.error(res.message || 'Lỗi tải thống kê nhắc hẹn');
        }
      },
      (err) => {
        this.toastr.error('Có lỗi xảy ra khi gọi API');
      }
    );
  }

  loadWarrantyLogs() {
    let params: any = {
      page: this.warrantyFilter.page,
      pageSize: this.warrantyFilter.pageSize
    };

    if (this.warrantyFilter.type !== 'all') {
      params.type = this.warrantyFilter.type;
    }
    if (this.warrantyFilter.status !== 'all') {
      params.status = this.warrantyFilter.status;
    }
    if (this.warrantyFilter.sentTime && this.warrantyFilter.sentTime.length === 2) {
      params.from = moment(this.warrantyFilter.sentTime[0]).format('YYYY-MM-DD');
      params.to = moment(this.warrantyFilter.sentTime[1]).format('YYYY-MM-DD');
    }

    this.apiEvsService.get('/qr-core-aps/warranty-reminder/history', params).subscribe(
      (res: any) => {
        if (res.code === 1) {
          this.filteredWarrantyLogs = res.data.items || [];
          this.warrantyTotalRow = res.data.pagination ? res.data.pagination.totalItems : 0;
          this.warrantyTotalPage = res.data.pagination ? res.data.pagination.totalPages : 0;
          this.generateWarrantyPagination();
        } else {
          this.toastr.error(res.message || 'Lỗi tải danh sách lịch sử', 'Thất bại');
        }
      },
      (err) => {
        this.toastr.error('Có lỗi xảy ra khi gọi API', 'Thất bại');
      }
    );
  }

  generateWarrantyPagination() {
    this.warrantyPages = [];
    if (this.warrantyTotalPage <= 1) return;
    let start = Math.max(1, this.warrantyFilter.page - 2);
    let end = Math.min(this.warrantyTotalPage, this.warrantyFilter.page + 2);
    for (let i = start; i <= end; i++) {
      this.warrantyPages.push(i);
    }
  }

  setWarrantyPage(page: number) {
    if (page < 1 || page > this.warrantyTotalPage) return;
    this.warrantyFilter.page = page;
    this.loadWarrantyLogs();
  }

  onFilterWarrantyLogs() {
    this.warrantyFilter.page = 1;
    this.loadWarrantyLogs();
  }

  onResetWarrantyFilter() {
    this.warrantyFilter.type = 'all';
    this.warrantyFilter.status = 'all';
    this.warrantyFilter.sentTime = null;
    this.warrantyFilter.page = 1;
    this.loadWarrantyLogs();
  }
  constructor(
    private statisticService: StampStatisticsService,
    private apiEvsService: ApiEvsService,
    private _fb: FormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private batchService: BatchService,
    public addressService: EvsAddressService,
    private translate: TranslateService
  ) {
    that = this;
  }

  fromDate: any;
  toDate: any;
  batchPage_Size: any = 4;
  batchCurrentPage: any = 1;
  totalBatchPage: any = 0;

  storePage_Size: any = 4;
  storeCurrentPage: any = 1;
  totalStorePage: any = 0;

  provincePage_Size: any = 4;
  provinceCurrentPage: any = 1;
  totalProvincePage: any = 0;

  warningPage_Size: any = 4;
  warningCurrentPage: any = 1;
  totalWarningPage: any = 0;

  alertRepeatTime: any = 0;
  warningUsageTime: any = 0;
  warningFake: any = 0;
  warningOverflow: any = 0;

  tab: any = 2;

  colors: any = [
    {
      id: 1,
      color: '#061178',
    },
    {
      id: 2,
      color: '#926dde',
    },
    {
      id: 3,
      color: '#7dd3ae',
    },
    {
      id: 4,
      color: '#9bee48',
    },
    {
      id: 5,
      color: '#70726d',
    },
    {
      id: 6,
      color: '#df0f57',
    },
    {
      id: 7,
      color: '#317187',
    },
    {
      id: 8,
      color: '#d7cbb6',
    },
  ];

  stamBuy: any = {};

  ngOnInit() {
    this.loadWarrantyDashboard();
    this.loadWarrantyLogs();
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_dashboardView', 'homepage', '');
    visibleContent('qcheck_dashboardView', 'qcheck_dashboardView', '')
    $('#inputStart').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputEnd').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputStartWarning').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputEndWarning').datepicker({ format: 'dd/mm/yyyy' });

    $('#inputStartPP').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputEndPP').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputStartBH').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputEndBH').datepicker({ format: 'dd/mm/yyyy' });
    $('.slt-batchstamp').select2({
      placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });
    $('.slt-batchstampBH').select2({
      placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });
    $('.slt-batchstampPP').select2({
      placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });

    const modalTypeStamp = $('#modaltypestamp');

    modalTypeStamp.select2({
      placeholder: this.translate.instant('CHON_LOAI_TEM'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    modalTypeStamp.on('select2:select', function (e) {
      that.stamBuy.typeStamp = parseInt(e.target.value);
      console.log('va', e.target.value);
      if (e.target.value == 1) {
        that.stamBuy.chongia = true;
        that.stamBuy.baohanh = true;
        that.stamBuy.tranhang = true;
        that.stamBuy.dinhdanh = true;
        that.isDisableService = true;
      } else {
        that.stamBuy.chongia = false;
        that.stamBuy.baohanh = false;
        that.stamBuy.tranhang = false;
        that.stamBuy.dinhdanh = false;
        that.isDisableService = false;
      }
    });


    this.getOverview();
    this.getOrder();
    this.changeTime();
    this.changeTimeWarning();
    // this.changeTimePP();
    this.changeTimeBH();
    this.getAlertRepeatTimeList();
    this.getData();

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['tab']) {
        this.tabBase = parseInt(params['tab']);
      }
    });
  }

  public checkValidateAccount: any;
  public dataValidateAccount: any;

  async getData() {
    await this.addressService.validateAccountSaleOut().subscribe((res) => {
      console.log('ressss', res)
      if (res.data.items.length == 0) {
        this.checkValidateAccount = false;
      } else {
        const data = res.data.items;
        data.map((val) => {
          if (val.systemType == 0) {
            this.dataValidateAccount = val
          }
        })
      }
      console.log('this.dataValidateAccount', this.dataValidateAccount)
      if (this.dataValidateAccount) {
        this.checkValidateAccount = true;
      }
      localStorage.setItem('checkValidateAccount', this.checkValidateAccount)
    })
  }

  changeTab(e: any) {
    console.log(e)
    this.tabBase = e
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.id,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  getOverview() {
    this.statisticService.getDashboardOverview().subscribe((res) => {
      this.overView = res.data;
    });
  }

  getOrder() {
    const data: any = {};
    this.statisticService.getDashboardOrders(data).subscribe((res) => {
      this.orders = res.data;
      if (this.orders.length > 0) {
        for (let i = 0; i < this.orders.length; i++) {
          this.orders[i]['list_services'] = [];
          const services = this.orders[i].services.split(',');
          for (let j = 0; j < services.length; j++) {
            const service: any = {};
            if (services[j] === '1') {
              service.id = 1;
              service.name = 'CHONG_GIA';

              this.orders[i]['list_services'].push(service);
            }
            if (services[j] === '2') {
              service.id = 2;
              service.name = 'BAO_HANH';

              this.orders[i]['list_services'].push(service);
            }
            if (services[j] === '3') {
              service.id = 3;
              service.name = 'TRAN_HANG';

              this.orders[i]['list_services'].push(service);
            }
            if (services[j] === '5') {
              service.id = 5;
              service.name = 'INH_DANH';

              this.orders[i]['list_services'].push(service);
            }
          }
        }
        //console.log(this.orders)
      }
      setTimeout(() => {
        const tableWidth = $('#tableLef').width();
        $('#titleLef').width(tableWidth);
      }, 0);
    });
  }

  setBatchPage(page: number) {
    if (page <= this.totalBatchPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalBatchPage) {
        page = this.totalBatchPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.batchCurrentPage) {
        this.batchCurrentPage = page;
        this.getBatch();
      }
    } else {
      page = this.totalBatchPage;
      if (page <= 0) {
        this.toastr.warning('Không có dữ liệu tình trạng lô tem ', '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputOrders').val(1);
        this.batchCurrentPage = 1;
      } else {
        this.toastr.warning(
          'Số trang tình trạng lô tem tối đa hiện tại là ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalBatchPage) {
          page = this.totalBatchPage;
        }
        $('#inputOrders').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.batchCurrentPage) {
          this.batchCurrentPage = page;
          this.getBatch();
        }
      }
    }
  }

  goOrdersPage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setBatchPage(toPage);
    }
  }

  getBatch() {
    const data: any = {};
    data.offset =
      this.batchPage_Size *
      (this.batchCurrentPage <= 0 ? 0 : this.batchCurrentPage - 1);
    data.limit = this.batchPage_Size;
    data.sort_by = 'id:asc';
    this.statisticService.getDashboardBatchs(data).subscribe((res) => {
      if (!res.error) {
        //console.log(res.data.batches)
        this.batchs = res.data.batches;

        const item = res.data.total.count;
        const pageString = (item / this.batchPage_Size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalBatchPage = totalpage;
      }
    });
  }

  setStorePage(page: number) {
    if (page <= this.totalStorePage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalStorePage) {
        page = this.totalStorePage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.storeCurrentPage) {
        this.storeCurrentPage = page;
        this.getStore();
      }
    } else {
      page = this.totalStorePage;
      if (page <= 0) {
        this.toastr.warning('Không có dữ liệu tình trạng cửa hàng ', '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputStore').val(1);
        this.storeCurrentPage = 1;
      } else {
        this.toastr.warning(
          'Số trang tình trạng cửa hàng tối đa hiện tại là ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalStorePage) {
          page = this.totalStorePage;
        }
        $('#inputStore').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.storeCurrentPage) {
          this.storeCurrentPage = page;
          this.getStore();
        }
      }
    }
  }

  goStorePage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setStorePage(toPage);
    }
  }

  getStore() {
    const data: any = {};
    data.offset =
      this.storePage_Size *
      (this.storeCurrentPage <= 0 ? 0 : this.storeCurrentPage - 1);
    data.limit = this.storePage_Size;
    data.sort_by = 'id:asc';
    this.statisticService.getDashBoardStores(data).subscribe((res) => {
      if (!res.error) {
        this.stores = res.data.stores;

        const item = res.data.total.count;
        const pageString = (item / this.storePage_Size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalStorePage = totalpage;
      }
    });
  }

  setProvincePage(page: number) {
    if (page <= this.totalProvincePage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalProvincePage) {
        page = this.totalProvincePage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.provinceCurrentPage) {
        this.provinceCurrentPage = page;
        this.getPageProvince(this.provinceCurrentPage);
      }
    } else {
      page = this.totalProvincePage;
      if (page <= 0) {
        this.toastr.warning('Không có dữ liệu tình trạng cửa hàng ', '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputProvince').val(1);
        this.provinceCurrentPage = 1;
      } else {
        this.toastr.warning(
          'Số trang tình trạng cửa hàng tối đa hiện tại là ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalProvincePage) {
          page = this.totalProvincePage;
        }
        $('#inputProvince').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.storeCurrentPage) {
          this.provinceCurrentPage = page;
          this.getPageProvince(this.provinceCurrentPage);
        }
      }
    }
  }

  goProvincePage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setProvincePage(toPage);
    }
  }

  getProvince() {
    const data: any = {};
    data.offset =
      this.provincePage_Size *
      (this.provinceCurrentPage <= 0 ? 0 : this.provinceCurrentPage - 1);
    data.limit = this.provincePage_Size;
    data.sort_by = 'id:asc';
    this.statisticService.getDashBoardCity(data).subscribe((res) => {
      if (!res.error) {
        this.provinces = res.data;
        const item = res.data.length;
        const pageString = (item / this.provincePage_Size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalProvincePage = totalpage;
      }
      this.getPageProvince(this.provinceCurrentPage);
    });
  }

  getPageProvince(page: number) {
    const last_index = page * 4 - 1;
    const list_data = [];
    for (let i = last_index - 3; i <= last_index; i++) {
      if (this.provinces[i]) {
        list_data.push(this.provinces[i]);
      }
    }
    this.province_data_page = list_data;
  }

  changeTimeBH() {
    let startDate: any = moment().startOf('month');
    let endDate: any = moment();
    $('#inputStartBH').datepicker('update', startDate._d);
    $('#inputEndBH').datepicker('update', endDate._d);
    $('.slt-batchstampBH').val('').trigger('change');
    // var days = ((endDate['_d'] - startDate['_d']) / (24 * 3600 * 1000)).toFixed(0);
    this.filterChartBH();
  }

  filterChartBH() {
    let startDate: any = '';
    let endDate: any = '';
    let name: string = '';
    if ($('#inputStartBH').val()) {
      startDate = moment($('#inputStartBH').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('#inputEndBH').val()) {
      endDate = moment($('#inputEndBH').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('.slt-batchstampBH').val()) {
      name = $('.slt-batchstampBH').text();
    }
    const days = parseInt(
      ((endDate - startDate) / (24 * 3600 * 1000)).toFixed(0)
    );
    console.log(1, endDate, startDate)
    const startSateFM = UtilityService.getFormattedDate(startDate);
    const endSateFM = UtilityService.getFormattedDate(endDate);
    this.getScanStatusBH(startSateFM, endSateFM, days, startDate, endDate);
    let data_search_tracking = {
      startDate: startDate,
      endDate: endDate,
      name: name
    }
    searchEvent(JSON.stringify(data_search_tracking), JSON.stringify(data_search_tracking), '', '');

  }

  getScanStatusBH(startDateMM: any, endDateMM: any, days, startDate, endDate) {
    if (days >= 60) {
      this.toastr.warning(
        'Chỉ được lọc tối đa trong khoảng thời gian 60 ngày',
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        }
      );
    } else {
      // $(".lineChart").css("width", "100%");
      // $("#idWarning").css("padding-top", "20px")
      // if (days >= 15) {
      //     $(".lineChart").css("width", "100%");
      //     $("#idWarning").css("padding-top", "20px")
      // } else {
      //     $(".lineChart").css({ 'width': 'calc(100% - ' + 500 + 'px)' });
      //     $("#idWarning").css("padding-top", "10px")
      // }
      const data: any = {};
      data.from = startDateMM;
      data.to = endDateMM;
      if ($('.slt-batchstampBH').val()) {
        data.batch_ids = $('.slt-batchstampBH').val();
      }

      this.statisticService.getDashboardStatisticsBH(data).subscribe((res) => {
        this.getDashboardStatisticsBH = res.data
        console.log('res', this.getDashboardStatisticsBH)
      });


    }
  }

  changeTimePP() {

    let startDate: any = moment().startOf('month');
    let endDate: any = moment();

    $('#inputStartPP').datepicker('update', startDate._d);
    $('#inputEndPP').datepicker('update', endDate._d);
    $('.slt-batchstampPP').val('').trigger('change');
    // var days = ((endDate['_d'] - startDate['_d']) / (24 * 3600 * 1000)).toFixed(0);
    this.filterChartPP();
  }

  filterChartPP() {
    let startDate: any = '';
    let endDate: any = '';
    let name: string = '';
    if ($('#inputStartPP').val()) {
      startDate = moment($('#inputStartPP').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('#inputEndPP').val()) {
      endDate = moment($('#inputEndPP').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('.slt-batchstampPP').val()) {
      name = $('.slt-batchstampPP').text();
    }
    const days = parseInt(
      ((endDate - startDate) / (24 * 3600 * 1000)).toFixed(0)
    );
    console.log(1, endDate, startDate)
    const startSateFM = UtilityService.getFormattedDate(startDate);
    const endSateFM = UtilityService.getFormattedDate(endDate);
    this.getScanStatusPP(startSateFM, endSateFM, days, startDate, endDate);

    let data_search_tracking = {
      startDate: startDate,
      endDate: endDate,
      name: name
    }
    searchEvent(JSON.stringify(data_search_tracking), JSON.stringify(data_search_tracking), '', '');
  }

  getScanStatusPP(startDateMM: any, endDateMM: any, days, startDate, endDate) {
    if (days >= 60) {
      this.toastr.warning(
        'Chỉ được lọc tối đa trong khoảng thời gian 60 ngày',
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        }
      );
    } else {
      // $(".lineChart").css("width", "100%");
      // $("#idWarning").css("padding-top", "20px")
      // if (days >= 15) {
      //     $(".lineChart").css("width", "100%");
      //     $("#idWarning").css("padding-top", "20px")
      // } else {
      //     $(".lineChart").css({ 'width': 'calc(100% - ' + 500 + 'px)' });
      //     $("#idWarning").css("padding-top", "10px")
      // }
      const data: any = {};
      data.from = startDateMM;
      data.to = endDateMM;
      if ($('.slt-batchstampPP').val()) {
        data.batch_ids = $('.slt-batchstampPP').val();
      }

      this.statisticService.getDashboardStatisticsPP(data).subscribe((res) => {
        this.getDashboardStatisticsPP = res.data
        console.log(' this.getDashboardStatisticsPP', this.getDashboardStatisticsPP)
        // distributed: 0 phan phoi
        // imported: 0 nhap hang
        // inventory: 11141858  ton kho
        // refunded: 0 tra lai
        // returned: 0 tra hang
        // revoke: 0 thu hoi 1
        // takeBack: 0 thu hoi 2


        // const item = {};
        // const alertRepeatTime = res.data.alertRepeatTime;
        // const warningUsageTime = res.data.warningUsageTime;
        // const warningFake = res.data.warningFake;
        // const warningOverflow = res.data.warningOverflow;
        // // alertRepeatTime: any = 0;
        // // warningUsageTime: any = 0;
        // // warningFake: any = 0;
        // // warningOverflow: any = 0;
        // // console.log(warningFake);
        // const listData = [];
        //
        // for (let i = days; i >= 0; i--) {
        //   item['day'] = UtilityService.getFormattedDate(
        //     moment(endDate).subtract(i, 'd')['_d']
        //   );
        //   item['warningFake'] = 0;
        //   item['warningOverflow'] = 0;
        //   item['alertRepeatTime'] = 0;
        //   item['warningUsageTime'] = 0;
        //   for (let j = 0; j < warningFake.length; j++) {
        //     if (warningFake[j]['date'] === item['day']) {
        //       item['warningFake'] = warningFake[j]['count'];
        //       this.warningFake += Number(warningFake[j]['count'])
        //     }
        //   }
        //   for (let j = 0; j < warningOverflow.length; j++) {
        //     if (warningOverflow[j]['date'] === item['day']) {
        //       item['warningOverflow'] = warningOverflow[j]['count'];
        //       this.warningOverflow += Number(warningOverflow[j]['count'])
        //
        //     }
        //   }
        //
        //   for (let j = 0; j < alertRepeatTime.length; j++) {
        //     if (alertRepeatTime[j]['date'] === item['day']) {
        //       item['alertRepeatTime'] = alertRepeatTime[j]['count'];
        //       this.alertRepeatTime += Number(alertRepeatTime[j]['count'])
        //
        //     }
        //   }
        //
        //   for (let j = 0; j < warningUsageTime.length; j++) {
        //     if (warningUsageTime[j]['date'] === item['day']) {
        //       item['warningUsageTime'] = warningUsageTime[j]['count'];
        //       this.warningUsageTime += Number(warningUsageTime[j]['count'])
        //
        //     }
        //   }
        //   listWarningFake.push(item['warningFake']);
        //   listWarningOverflow.push(item['warningOverflow']);
        //   listAlertRepeatTime.push(item['alertRepeatTime']);
        //   listWarningUsageTime.push(item['warningUsageTime']);
        //   dayCount = new Date(item['day']);
        //   listDays.push(dayCount.getDate());
        // }
        // if ($('#statusScanWarning').length > 0) {
        //   new Chartist.Line(
        //     '#statusScanWarning',
        //     {
        //       labels: listDays,
        //       series: [listWarningFake, listWarningOverflow, listAlertRepeatTime, listWarningUsageTime],
        //     },
        //     {
        //       height: '300px',
        //       fullWidth: true,
        //       chartPadding: {},
        //       //showArea: true,
        //       low: 0,
        //       plugins: [Chartist.plugins.tooltip()],
        //       axisY: {
        //         onlyInteger: true,
        //       },
        //     }
        //   );
        // }
      });


    }
  }


  changeTimeWarning() {

    let startDate: any = moment().startOf('month');
    let endDate: any = moment();

    $('#inputStartWarning').datepicker('update', startDate._d);
    $('#inputEndWarning').datepicker('update', endDate._d);
    $('.slt-batchstamp').val('').trigger('change');
    // var days = ((endDate['_d'] - startDate['_d']) / (24 * 3600 * 1000)).toFixed(0);
    this.filterChartWarning();
  }

  filterChartWarning() {
    console.log('tuanba', 12323123123)
    let startDate: any = '';
    let endDate: any = '';
    let name: any = '';
    let data_search_tracking: any = {};
    if ($('#inputStartWarning').val()) {
      startDate = moment($('#inputStartWarning').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('#inputEndWarning').val()) {
      endDate = moment($('#inputEndWarning').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('.slt-batchstamp').val()) {
      name = $('.slt-batchstamp').text();
    }
    const days = parseInt(
      ((endDate - startDate) / (24 * 3600 * 1000)).toFixed(0)
    );
    console.log(1, endDate, startDate)
    const startSateFM = UtilityService.getFormattedDate(startDate);
    const endSateFM = UtilityService.getFormattedDate(endDate);
    this.getScanStatusWarning(startSateFM, endSateFM, days, startDate, endDate);
    data_search_tracking = {
      startDate: startDate,
      endDate: endDate,
      name: name
    }
    searchEvent(JSON.stringify(data_search_tracking), JSON.stringify(data_search_tracking), '', '');
  }

  getScanStatusWarning(startDateMM: any, endDateMM: any, days, startDate, endDate) {
    if (days >= 60) {
      this.toastr.warning(
        'Chỉ được lọc tối đa trong khoảng thời gian 60 ngày',
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        }
      );
    } else {
      // $(".lineChart").css("width", "100%");
      // $("#idWarning").css("padding-top", "20px")
      // if (days >= 15) {
      //     $(".lineChart").css("width", "100%");
      //     $("#idWarning").css("padding-top", "20px")
      // } else {
      //     $(".lineChart").css({ 'width': 'calc(100% - ' + 500 + 'px)' });
      //     $("#idWarning").css("padding-top", "10px")
      // }
      const data: any = {};
      data.from = startDateMM;
      data.to = endDateMM;
      if ($('.slt-batchstamp').val()) {
        data.batch_ids = $('.slt-batchstamp').val();
      }
      const listWarningFake: any = [];
      const listWarningOverflow: any = [];
      const listAlertRepeatTime: any = [];
      const listWarningUsageTime: any = [];
      const listDays: any = [];
      let dayCount = new Date();
      this.warningFake = 0
      this.warningUsageTime = 0
      this.warningOverflow = 0
      this.alertRepeatTime = 0
      this.statisticService.getDashboardStatisticsWarning(data).subscribe((res) => {
        console.log('res', res)
        const item = {};
        const alertRepeatTime = res.data.alertRepeatTime;
        const warningUsageTime = res.data.warningUsageTime;
        const warningFake = res.data.warningFake;
        const warningOverflow = res.data.warningOverflow;
        // alertRepeatTime: any = 0;
        // warningUsageTime: any = 0;
        // warningFake: any = 0;
        // warningOverflow: any = 0;
        // console.log(warningFake);
        const listData = [];

        for (let i = days; i >= 0; i--) {
          item['day'] = UtilityService.getFormattedDate(
            moment(endDate).subtract(i, 'd')['_d']
          );
          item['warningFake'] = 0;
          item['warningOverflow'] = 0;
          item['alertRepeatTime'] = 0;
          item['warningUsageTime'] = 0;
          for (let j = 0; j < warningFake.length; j++) {
            if (warningFake[j]['date'] === item['day']) {
              item['warningFake'] = warningFake[j]['count'];
              this.warningFake += Number(warningFake[j]['count'])
            }
          }
          for (let j = 0; j < warningOverflow.length; j++) {
            if (warningOverflow[j]['date'] === item['day']) {
              item['warningOverflow'] = warningOverflow[j]['count'];
              this.warningOverflow += Number(warningOverflow[j]['count'])

            }
          }

          for (let j = 0; j < alertRepeatTime.length; j++) {
            if (alertRepeatTime[j]['date'] === item['day']) {
              item['alertRepeatTime'] = alertRepeatTime[j]['count'];
              this.alertRepeatTime += Number(alertRepeatTime[j]['count'])

            }
          }

          for (let j = 0; j < warningUsageTime.length; j++) {
            if (warningUsageTime[j]['date'] === item['day']) {
              item['warningUsageTime'] = warningUsageTime[j]['count'];
              this.warningUsageTime += Number(warningUsageTime[j]['count'])

            }
          }
          listWarningFake.push(item['warningFake']);
          listWarningOverflow.push(item['warningOverflow']);
          listAlertRepeatTime.push(item['alertRepeatTime']);
          listWarningUsageTime.push(item['warningUsageTime']);
          dayCount = new Date(item['day']);
          listDays.push(dayCount.getDate());
        }
        if ($('#statusScanWarning').length > 0) {
          new Chartist.Line(
            '#statusScanWarning',
            {
              labels: listDays,
              series: [listWarningFake, listWarningOverflow, listAlertRepeatTime, listWarningUsageTime],
            },
            {
              height: '300px',
              fullWidth: true,
              chartPadding: {},
              //showArea: true,
              low: 0,
              plugins: [Chartist.plugins.tooltip()],
              axisY: {
                onlyInteger: true,
              },
            }
          );
        }
      });


    }
  }

  changeTime() {
    let startDate: any = '';
    let endDate: any = '';

    switch (this.tab) {
      case 1: {
        startDate = moment();
        endDate = moment();
        break;
      }
      case 2: {
        startDate = moment().startOf('week');
        endDate = moment();
        break;
      }
      case 3: {
        startDate = moment().startOf('month');
        endDate = moment();
        break;
      }
    }
    $('#inputStart').datepicker('update', startDate._d);
    $('#inputEnd').datepicker('update', endDate._d);
    //var days = ((endDate['_d'] - startDate['_d']) / (24 * 3600 * 1000)).toFixed(0);
    this.filterChart();
  }

  filterChart() {
    let startDate: any = '';
    let endDate: any = '';
    if ($('#inputStart').val()) {
      startDate = moment($('#inputStart').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('#inputEnd').val()) {
      endDate = moment($('#inputEnd').val(), ['DD/MM/YYYY'])['_d'];
    }
    const days = parseInt(
      ((endDate - startDate) / (24 * 3600 * 1000)).toFixed(0)
    );
    console.log(2, endDate, startDate)

    const startSateFM = UtilityService.getFormattedDate(startDate);
    const endSateFM = UtilityService.getFormattedDate(endDate);
    this.getScanStatus(startSateFM, endSateFM, days, startDate, endDate);
    let data_search_tracking = {
      startDate: startDate,
      endDate: endDate,
    }
    searchEvent(JSON.stringify(data_search_tracking), JSON.stringify(data_search_tracking), '', '');
  }

  getScanStatus(startDateMM: any, endDateMM: any, days, startDate, endDate) {
    if (days >= 60) {
      this.toastr.warning(
        'Chỉ được lọc tối đa trong khoảng thời gian 60 ngày',
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        }
      );
    } else {
      // $(".lineChart").css("width", "100%");
      // $("#idWarning").css("padding-top", "20px")
      // if (days >= 15) {
      //     $(".lineChart").css("width", "100%");
      //     $("#idWarning").css("padding-top", "20px")
      // } else {
      //     $(".lineChart").css({ 'width': 'calc(100% - ' + 500 + 'px)' });
      //     $("#idWarning").css("padding-top", "10px")
      // }
      const data: any = {};
      data.from = startDateMM;
      data.to = endDateMM;

      this.statisticService
        .getDashboardScanLocation(data)
        .toPromise()
        .then((res) => {
          const dataPieFull: any = [];
          this.scanStatusLocation = res.data;
          this.scanStatusLocation = this.sort(this.scanStatusLocation);
          if (this.scanStatusLocation.length > 0) {
            let h = 0;
            let count_data: any = 0;
            for (let i = 0; i < this.scanStatusLocation.length; i++) {
              this.allLocation +=
                `<span>` +
                this.scanStatusLocation[i].city +
                `: ` +
                this.scanStatusLocation[i].count +
                `</span><br />`;
              if (h < 6) {
                for (let j = 0; j < this.colors.length; j++) {
                  if (this.colors[j]) {
                    if (i + 1 == this.colors[j].id) {
                      if (this.scanStatusLocation[i]) {
                        this.scanStatusLocation[i]['color'] = this.colors[
                          j
                        ].color;
                        dataPieFull.push(this.scanStatusLocation[i].count);
                      }
                    }
                  }
                }
              } else {
                count_data += this.scanStatusLocation[i].count;
              }
              h++;
            }
            if (count_data > 0) {
              this.scanStatusLocation[6]['color'] = this.colors[6].color;
              this.scanStatusLocation[6]['count'] = count_data;
              dataPieFull.push(count_data);
              this.scanStatusLocation[6]['city'] = 'Khu vực khác';
            }
            if (this.scanStatusLocation.length > 7) {
              this.scanStatusLocation.splice(
                7,
                this.scanStatusLocation.length - 6
              );
            }
            if (days >= 15) {
              $('.lineChart').css('width', '100%');
            } else {
              $('.lineChart').css({ width: 'calc(100% - ' + 500 + 'px)' });
            }
          } else {
            $('.lineChart').css('width', '100%');
          }

          const dataPie = {
            series: dataPieFull,
          };
          console.log('dataPiesss', dataPie)
          const options = {
            labelInterpolationFnc: function (value) {
              if (value) {
                return value[0];
              }
            },
          };
          if ($('#statusScanWithLocation').length > 0) {
            new Chartist.Pie('#statusScanWithLocation', dataPie, options);
          }

          ////////////////////////////////////

          const listCount: any = [];
          const listWarning: any = [];
          const listDays: any = [];
          let dayCount = new Date();
          this.statisticService.getDashboardScans(data).subscribe((res) => {
            const item = {};
            const listDataStatus = res.data.scan;
            const listDataWarning = res.data.warning;

            //console.log(listDataStatus);
            const listData = [];

            for (let i = days; i >= 0; i--) {
              item['day'] = UtilityService.getFormattedDate(
                moment(endDate).subtract(i, 'd')['_d']
              );
              item['count'] = 0;
              item['warning'] = 0;
              for (let j = 0; j < listDataStatus.length; j++) {
                if (listDataStatus[j]['date'] === item['day']) {
                  item['count'] = listDataStatus[j]['count'];
                }
              }
              for (let j = 0; j < listDataWarning.length; j++) {
                if (listDataWarning[j]['date'] === item['day']) {
                  item['warning'] = listDataWarning[j]['count'];
                }
              }
              listCount.push(item['count']);
              listWarning.push(item['warning']);
              dayCount = new Date(item['day']);
              listDays.push(dayCount.getDate());
            }
            if ($('#statusScan').length > 0) {
              new Chartist.Line(
                '#statusScan',
                {
                  labels: listDays,
                  series: [listCount, listWarning],
                },
                {
                  height: '300px',
                  fullWidth: true,
                  chartPadding: {},
                  //showArea: true,
                  low: 0,
                  plugins: [Chartist.plugins.tooltip()],
                  axisY: {
                    onlyInteger: true,
                  },
                }
              );
            }
          });
        });
    }
  }

  showReStore(item: any) {
    const detail = {
      name: item.batch.name,
      id: item.batch_id,
      id_start: item.number,
      id_end: item.number,
      prefix: item.prefix,
      readonly: true,
    };

    const initialState = { batch_detail: detail };
    this.modalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.modalRef.content.closeBtnName = 'Bỏ qua';
  }

  showReStoreBatch(item: any) {
    this.batchService
      .getBatchDetail(item.batch_id)
      .toPromise()
      .then((res: any) => {
        const data = res.data;

        const detail = {
          name: data.name,
          id: item.batch_id,
          id_start: data.id_start,
          id_end: data.id_end,
          prefix: data.prefix,
          readonly: true,
        };
        const initialState = { batch_detail: detail };
        this.modalRef = this.modalService.show(ModalCancelStampComponent, {
          initialState,
        });
        this.modalRef.content.closeBtnName = 'Bỏ qua';
      });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  navigateTo(page: any) {
    console.log(page);
    switch (page) {
      case 'order': {
        this.router.navigate(['/qrcode/order']);
        break;
      }
      case 'batch': {
        clickTracking('qcheck_dashboardView', 'batchtotal', 'qcheck_batch_manage', '')
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 'batch_active': {
        clickTracking('qcheck_dashboardView', 'stamp_active_total', 'qcheck_batch_manage', '')
        this.router.navigate(['/qrcode/batchstamp/list/'], {
          queryParams: { status: 2 },
        });
        break;
      }
      case 'customer': {
        clickTracking('qcheck_dashboardView', 'customer_total', 'qcheck_user_manage', '')
        this.router.navigate(['/qrcode/customer/list']);
        break;
      }
      case 'warning': {
        clickTracking('qcheck_dashboardView', 'warning_total', 'qcheck_warning_general_view', '')
        this.changeTab(5);
        break;
      }
      case 'repeat': {
        clickTracking('qcheck_dashboardView', 'alert_total', 'qcheck_alert_view', '')
        this.changeTab(5);
        break;
      }
    }
  }

  scrollToWarning() {
    let offset: any;
    if ($('#idWarning').length && $('#idWarning').length > 0) {
      //console.log('co cg');
      offset = $('#idWarning').offset().top - $('#page-content').offset().top;
    }

    $('#page-content').animate(
      { scrollTop: offset },
      500,
      'swing',
      function () {
      }
    );
  }

  buyStamp() {
    const listService: any = [];
    const request: any = {};
    if (this.stamBuy.chongia) {
      listService.push(1);
    }
    if (this.stamBuy.baohanh) {
      listService.push(2);
    }
    if (this.stamBuy.tranhang) {
      listService.push(3);
    }
    if (this.stamBuy.dinhdanh) {
      listService.push(5);
    }

    request.services = listService;
    request.quantity = parseInt(this.stamBuy.soluong);
    if ($('#modaltypestamp').val()) {
      this.stamBuy.typeStamp = parseInt($('#modaltypestamp').val());
      request.order_type = this.stamBuy.typeStamp;
    } else {
      request.order_type = null;
    }

    // if (listService.length <= 0) {
    //   this.toastr.warning('Bạn phải chọn dịch vụ ', '', {
    //     timeOut: 3000,
    //     positionClass: 'toast-bottom-right',
    //   });
    // } else {
    //   request.services = listService;
    // }
    // if (!this.stamBuy.soluong) {
    //   this.toastr.warning('Bạn phải nhập số lượng ', '', {
    //     timeOut: 3000,
    //     positionClass: 'toast-bottom-right',
    //   });
    // } else {
    //   request.quantity = parseInt(this.stamBuy.soluong);
    // }
    if (request.services && request.quantity) {
      this.statisticService.buyStamp(request).subscribe((res) => {
        if (!res.error) {
          this.lgModal.hide();
          this.toastr.success('Tạo đơn hàng thành công', '', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.toastr.error('Tạo đơn hàng thất bại', '', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
    }
  }

  viewDetail(data: any, page: number) {
    switch (page) {
      case 1: {
        this.router.navigate(['/evs/log-scan'], {
          queryParams: { response: 'warning', batch_id: data.id },
        });
        break;
      }
      case 2: {
        this.router.navigate(['/evs/guarantee/logs'], {
          queryParams: { status: 2, batch_id: data.id },
        });
        break;
      }
      case 3: {
        this.router.navigate(['/qrcode/distribution'], {
          queryParams: { batch_id: data.id },
        });
        break;
      }
      case 4: {
        this.router.navigate(['/qrcode/withdrawal'], {
          queryParams: { batch_id: data.id },
        });
        break;
      }
    }
  }

  sort(arr) {
    if (arr.length) {
      let _arr: any = [];
      for (let i = 0; i < arr.length; i++) {
        for (let j = arr.length - 1; j >= 0; j--) {
          if (arr[i].count < arr[j].count) {
            _arr.push(arr[i]);
            _arr.push(arr[j]);
            arr[i] = _arr[1];
            arr[j] = _arr[0];
            _arr = [];
          }
        }
      }
      const list: any = [];
      list.push(arr[arr.length - 1]);
      let h = 0;
      const leng = arr.length - 1;
      while (h < leng) {
        list.push(arr[h]);
        h++;
      }
      return list;
    }
    return [];
  }

  // get warning repeat time
  getAlertRepeatTimeList() {
    const opt = {
      limit: 10,
      offset: 0,
    };
    this.statisticService
      .getAlertRepeatTimeList(opt)
      .toPromise()
      .then((res) => {
        if (!res.error) {
          this.countAlertRepeatTime = Number(res.data.total.total)
            ? Number(res.data.total.total)
            : 0;
        }
      });
  }

  //  Tuanba: 14/06/2022
  resetModal() {
    this.stamBuy = {};
    $('#modaltypestamp').val('').trigger('change');
    this.isDisableService = false;
  }

  onSubmitModal(form) {
    console.log('12312312', form)
    this.buyStamp();
  }

  checkIfDirty($event: Event) {
    console.log($event)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/statistics/stamp-evs-dashboard.component.ts